import React, { useContext } from 'react';
import GlobalContext from '../../../contexts/GlobalContext';
import { Icon, Step } from 'semantic-ui-react';
import Utility from '../../../Utility';
import './StepAccount.css';

const StepAccount = (props) => {
  const [globalContext] = useContext(GlobalContext);
  const listItems = [
    Utility.getHeaderPage('connectionAndSetting', globalContext.translations),
    Utility.getHeaderPage('personalInformation', globalContext.translations),
    Utility.getHeaderPage('addressCP', globalContext.translations),
    Utility.getHeaderPage('additionalInformation', globalContext.translations),
    Utility.getHeaderPage('deleteAccount', globalContext.translations),
  ];

  const handleClick = (event) => {
    let lien = event.target;
    if (Utility.lowerCase(lien.tagName) !== 'a') {
      lien = event.target.closest('.step');
    }
    props.handleChangePage(lien.getAttribute('codepage'), lien.getAttribute('sens'));
  }

  const getStep = (listItems) => {
    const listStep = [];
    let sens = 'before';
    for (let i = 0; i < listItems.length; i++) {
      let active = false;
      if (listItems[i].codePage === props.codePage) {
        sens = 'after';
        active = true;
      }

      listStep.push(
        <Step key={i} active={active} onClick={handleClick} codepage={listItems[i].codePage} sens={sens} color="red">
          <Icon name={listItems[i].icon} />
          <Step.Content>
            <Step.Title>{listItems[i].header}</Step.Title>
          </Step.Content>
        </Step>
      );
    };

    return listStep;
  }

  return (
    <Step.Group widths={listItems.length} id="stepAccount">
      {getStep(listItems)}
    </Step.Group>
  )
}

export default StepAccount;